import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import router from './router'
import store from './store'
import VueMobileDetection from 'vue-mobile-detection'

createApp(App).use(router).use(store).use(VueMobileDetection).mount('#app')
